// React import
import * as React from 'react';
// Standard layout imports
import { ISubActivityModel } from 'src/Entities/Activity/Activity';
import { format } from 'date-fns';
import mapMarker from 'src/images/map_marker.png';

interface IProps {
  subActivity: ISubActivityModel;
}
const SubActivitiesItemIsAdvertisement = ({ subActivity }: IProps) => {
  return (
    <div>
      <b className="has-text-black">{subActivity.name}</b>
      <div className="f5 fw5 has-text-black">
        <a
          target="_blank"
          className="text-inherit no-underline"
          href={'https://maps.google.com/?q=' + subActivity.location}
        >
          {subActivity.location}
          <img src={mapMarker} height="20px" className="align-middle ml-2" />
        </a>
      </div>
      <div className="w-12 border-b-4 border-gray-body pb-4 mb-2" />
    </div>
  );
};

export default SubActivitiesItemIsAdvertisement;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/Activity/subActivityItemIsAdvertisement.tsx